import request from '@/utils/request'

export interface AuthEventParams {
  tab?: string // 'login' | 'logout'
  page?: number
  limit?: number
  startDate?: string
  endDate?: string
  search?: string
  status?: string // 'failed' for login tab
}

export interface UserAuthHistoryParams {
  page?: number
  limit?: number
}

export const getAuthEvents = (params: AuthEventParams) =>
  request({
    url: '/admin/auth-events',
    method: 'get',
    params
  })

export const getUserAuthHistory = (userId: string, params?: UserAuthHistoryParams) =>
  request({
    url: `/admin/auth-events/user/${encodeURIComponent(userId)}`,
    method: 'get',
    params
  })
